import React, { Component } from "react";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getVendors } from "../../../../services/inventory/vendorService";
import withGlobalData from "../../common/withGlobalData";
class SearchVendor extends Component {
  state = {
    reload: this.props.globalData.reload,
    vendors: [],
  };

  componentDidMount() {
    this.getVendors();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getVendors();
      this.setState({ reload: globalData.reload });
    }
  }

  async getVendors() {
    const response = await getVendors();
    const { data } = response.data;
    this.setState({ open: false, vendors: data.vendors });
  }

  render() {
    const { vendors } = this.state;
    const { onSelectVendor } = this.props;
    return (
      <CustomDataTableSearch
        data={vendors}
        onRefreshData={() => {
          this.getVendors();
        }}
        onSelectedData={(rowData, originalEvent) => {
          onSelectVendor(rowData);
        }}
        columns={[
          {
            field: "select",
            body: (rowData) => (
              <React.Fragment>
                <button
                  type="button"
                  className="btn btn-label-success btn-sm btn-pill btn-bold"
                  onClick={() => onSelectVendor(rowData)}
                >
                  Select <i className="fas fa-angle-double-right"></i>
                </button>
              </React.Fragment>
            ),
          },
          {
            header: "Vendor ID",
            field: "ID",
            body: null,
            sortable: true,
          },
          {
            header: "Vendor Name",
            field: "vendorName",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.vendorName} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "Phone Number",
            field: "contactPhone",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.contactPhone} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
          {
            header: "City",
            field: "city",
            body: (rowData) => (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.city} maxLine="1" />
              </React.Fragment>
            ),
            sortable: true,
          },
        ]}
      />
    );
  }
}

export default withGlobalData(SearchVendor);
